import React from 'react'

import { toClasses } from 'lib/utilities'

export type ButtonColors = 'primary' | 'secondary' | 'tertiary' | 'light' | 'player2' | 'text'
interface ButtonStyle {
  small?: boolean
  className?: string
  icon?: boolean
  color?: ButtonColors
  fullColor?: boolean
  disabled?: boolean
  customClickEvent?: () => void
  children?: any
  size?: number | string
  width?: number
  square?: boolean
  ariaLabel?: string
  ariaPressed?: boolean
  title?: string
}

const Button: React.FC<ButtonStyle> = ({
  small = false,
  className = '',
  icon = false,
  color = 'primary',
  fullColor = false,
  disabled = false,
  customClickEvent = () => {},
  children = 'no-title',
  size,
  width,
  square = false,
  ariaLabel,
  ariaPressed,
  title,
}: ButtonStyle) => {
  const attributes = {
    disabled,
  }

  const customClick = () => {
    if (disabled) return
    customClickEvent()
  }

  const classes = {
    Button: true,
    'Button--disabled': disabled,
    'Button--small': small,
    'Button--primary': color === 'primary',
    'Button--secondary': color === 'secondary',
    'Button--tertiary': color === 'tertiary',
    'Button--player2': color === 'player2',
    'Button--light': color === 'light',
    'Button--text': color === 'text',
    'Button--full': fullColor || disabled,
    Icon: icon,
    'Button--square': square,
  }

  return (
    <button
      style={{
        width: width || size || '',
        height: size || '',
      }}
      onClick={() => customClick()}
      aria-label={ariaLabel}
      aria-pressed={ariaPressed}
      title={title}
      {...attributes}
      className={`${toClasses(classes)} ${className}`}
    >
      {children}
    </button>
  )
}
export default Button
